import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "../../components/modal";
import Button from "../../components/button";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import { Error } from "@progress/kendo-react-labels";
import FormHead from "../../components/headings/FromHead";



export type CrowdSourcingModalFields = {
    companyDetails: any;
}

interface props {
    ClickHandler?: any;
    defaultValues?: any;
    onClose?: any;
    enable?: any;
    companyDetails?: any;
}

const CrowdSourcingModal: React.FC<props> = ({
    onClose,
    ClickHandler,
    defaultValues,
    companyDetails,
    enable
}) => {
  const formOptions = {    defaultValues: useMemo(() => {
    return defaultValues;
  }, [defaultValues])};


  const { handleSubmit, setValue} = useForm<CrowdSourcingModalFields>(formOptions)

  const [error, setError] = useState<string>('')
  const [editorState2, setEditorState2] = useState<any>(EditorState.createEmpty())

  useEffect(() => {
    
    if(companyDetails){
      setValue('companyDetails',companyDetails)
      setEditorState2(EditorState.createWithContent(convertFromRaw(JSON.parse(companyDetails)))) 
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[companyDetails])

  const onSubmit = (data: any) => { 
    
    let hasError: boolean = false

    if(!data.companyDetails){
      hasError = true
      setError('Field is required')
    }

    if (!hasError) {
      ClickHandler(data)
    } 
  }

  const onEditorStateChange2 = (state: any) => {
    setError('')
    setEditorState2(state);
    const contentState = state.getCurrentContent();
    setValue("companyDetails", JSON.stringify(convertToRaw(contentState)));
  }

  return (
    <Modal size="small" onClose={onClose}>
      <form>
        {enable === true && 
            <>
            <FormHead>{'Are you sure you want to enable Crowdsourcing?'}</FormHead>
            <div className="form-group">
                <label className="lablel">About the company*</label>
                <Editor
                    editorState={editorState2}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editorClassName"
                    onEditorStateChange={onEditorStateChange2}
                />
                <Error>{error}</Error>
            </div>
            <div className="popupAction">
                <Button variant="secondary" onClick={onClose}>Cancel</Button>
                <Button variant="primary" onClick={handleSubmit(onSubmit)}>Yes, Enable </Button>
            </div>
            </>
        }
        {enable === false &&
            <>
            <FormHead>{'Disable Crowdsourcing?'}</FormHead>
            <div className="form-group">
                <label className="lablel">Are you sure you want to disable Crowdsourcing? </label>
            </div>
            <div className="popupAction">
                <Button variant="secondary" onClick={onClose}>Cancel</Button>
                <Button variant="primary" onClick={handleSubmit(onSubmit)}>Yes, Disable </Button>
            </div>
            </>
        }  
      
      </form>
    </Modal>
  )
}

export default CrowdSourcingModal;
